import React from 'react';

import Layout from '../../components/layout/Layout';
import Card from '../../components/card/Card';

import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { FORMATTER_STYLE, getFormatter } from '../../utils/formatter';
import { Doughnut, HorizontalBar } from 'react-chartjs-2';
import { Col, Form, Grid, Row} from 'react-bootstrap';
import { getStat } from '../../redux/stat/stat_actions';
import { defaultRejectHandler } from '../../utils/utility';
import FieldGroup from '../../components/field_group/FieldGroup';
import * as moment from 'moment';

class StatisticPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: moment().startOf('month').format('YYYY-MM-DD'),
      endDate: moment().endOf('month').format('YYYY-MM-DD'),
    };

    this.scales = {
      xAxes: [{
        ticks: {
          callback: value => getFormatter(FORMATTER_STYLE.decimal)(value),
        },
      }],
      yAxes: [{
        ticks: {
          display: false,
        }
      }]
    }
  }

  getStat() {
    this.props.getStat(this.state.startDate, this.state.endDate);
  }

  componentDidMount() {
    this.getStat();
  }

  renderBuildingAmountChart() {
    const {
      stat: {
        buildings = [],
      },
      i18n,
    } = this.props;
    const lang = i18n.language.split('-')[0];
    const data = {
      labels: buildings.map(item => item[`name_${lang}`]),
      datasets: [{
        data: buildings.map(item => item.amount),
        backgroundColor: [
          '#96ceb4',
          '#ffeead',
          '#d9534f',
          '#ffad60',
          '#5bc0de',
          '#a4e46b',
          '#fb6f62',
          '#f69454',
          '#24978d',
          '#01796f',
        ],
        hoverBackgroundColor: [
          '#96ceb4',
          '#ffeead',
          '#d9534f',
          '#ffad60',
          '#5bc0de',
          '#a4e46b',
          '#fb6f62',
          '#f69454',
          '#24978d',
          '#01796f',
        ],
      }]
    };
    const total = buildings.reduce((sum, item) => sum + item.amount, 0);
    const options = {
      tooltips: {
        callbacks: {
          label: ({ datasetIndex, index }, { datasets }) => {
            const amount = datasets[datasetIndex].data[index];
            const amountPercentage = (amount * 100.0) / total;
            return ` ${amount} (${getFormatter(FORMATTER_STYLE.floatFractionDigit2)(amountPercentage)}%)`;
          },
        },
      },
    };
    return <Doughnut data={data} options={options} />;
  }

  renderEnergyConsumptionChart() {
    const {
      stat: { specific_energy_consumption = 0 },
      t,
    } = this.props;

    const data = {
      labels: [t('specific energy consumption')],
      datasets: [{
          label: `${t('specific energy consumption')} (${t('kWh/sq_m/Year')})`,
          data: [specific_energy_consumption],
          backgroundColor: 'rgba(255,72,0,1)',
          borderColor: 'rgba(255,99,132,1)',
          borderWidth: 1,
      }],
    };

    return <HorizontalBar data={data} options={{ scales: this.scales }} />
  }

  renderEnergySavingChart() {
    const {
      stat: { saving_energy = {} },
      t,
    } = this.props;

    const data = {
      labels: [t('energy saving')],
      datasets: [{
          label: `${t('energy saving')} (${t('kWh/Year')})`,
          data: [saving_energy.electricity],
          backgroundColor: 'rgba(255,72,0,1)',
          borderColor: 'rgba(255,99,132,1)',
          borderWidth: 1,
      }],
    };

    return <HorizontalBar data={data} options={{ scales: this.scales }} />
  }

  renderOilEqSavingChart() {
    const {
      stat: { saving_energy = {} },
      t,
    } = this.props;

    const data = {
      labels: [t('oil equivalent saving')],
      datasets: [{
          label: `${t('oil equivalent saving')} (${t('ktoe/year')})`,
          data: [saving_energy.oil_equivalent],
          backgroundColor: 'rgba(255,72,0,1)',
          borderColor: 'rgba(255,99,132,1)',
          borderWidth: 1,
      }],
    };

    return <HorizontalBar data={data} options={{ scales: this.scales }} />
  }

  renderCo2EmissionSavingChart() {
    const {
      stat: { saving_energy = {} },
      t,
    } = this.props;

    const data = {
      labels: [t('co2 emission saving')],
      datasets: [{
          label: `${t('co2 emission saving')} (${t('kCO2/year')})`,
          data: [saving_energy.emission],
          backgroundColor: 'rgba(255,72,0,1)',
          borderColor: 'rgba(255,99,132,1)',
          borderWidth: 1,
      }],
    };

    return <HorizontalBar data={data} options={{ scales: this.scales }} />
  }

  render() {
    const {
      t,
    } = this.props;

    const breadcrumbItems = [
      { name: t('statistics'), path: `/statistics` },
    ];

    return (
      <Layout history={this.props.history} breadcrumbItems={breadcrumbItems}>
        <Grid>
          <Row>
            <Col xs={12} sm={12} md={6} />
            <Col xs={12} sm={12} md={6}>
              <Form inline style={{ display: 'flex', justifyContent: 'space-between', flex: 1, margin: '15px 0' }}>
                <FieldGroup
                  id="filter-start-date"
                  label={t('start date')}
                  type="date"
                  value={this.state.startDate}
                  onChange={({ target: { value } }) => this.setState({ startDate: value }, () => { this.getStat() })}
                />
                <FieldGroup
                  id="filter-end-date"
                  label={t('end date')}
                  type="date"
                  value={this.state.startDate}
                  onChange={({ target: { value } }) => this.setState({ endDate: value }, () => { this.getStat() })}
                />
              </Form>
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={12} md={6}>
              <Card header={t('building amount')} padding={false}>
                {this.renderBuildingAmountChart()}
              </Card>
            </Col>
            <Col xs={12} sm={12} md={6}>
              <Card header={t('specific energy consumption')} padding={false}>
                {this.renderEnergyConsumptionChart()}
              </Card>
            </Col>
            <Col xs={12} sm={12} md={6}>
              <Card header={t('energy saving')} padding={false}>
                {this.renderEnergySavingChart()}
              </Card>
            </Col>
            <Col xs={12} sm={12} md={6}>
              <Card header={t('oil equivalent saving')} padding={false}>
                {this.renderOilEqSavingChart()}
              </Card>
            </Col>
            <Col xs={12} sm={12} md={6}>
              <Card header={t('co2 emission saving')} padding={false}>
                {this.renderCo2EmissionSavingChart()}
              </Card>
            </Col>
          </Row>
        </Grid>
      </Layout>
    );
  }
}

const mapStateToProps = state => ({
  stat: state.stat.stat,
  errorMessage: state.stat.errorMessage,
});

const mapDispatchToProps = dispatch => ({
  getStat: (startDate, endDate) => defaultRejectHandler(dispatch(getStat(startDate, endDate))),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(StatisticPage),
);



// WEBPACK FOOTER //
// ./src/pages/statistic/StatisticPage.js